export const START_CONTACT_US_ACTION = `START_CONTACT_US_ACTION`;
export const ERROR_CONTACT_US_ACTION = `ERROR_CONTACT_US_ACTION`;
export const SUCCESS_CONTACT_US_ACTION = `SUCCESS_CONTACT_US_ACTION`;
